import http from 'constants/config';

export const getAmenityService = (amenityId) => http.get(`v2/amenities/${ amenityId }`);
